import { accuracyTier } from '@/data/scoring';

// This-request verification accuracy as a compact, colour-tiered progress meter.
// Returns null when the answer has no score yet (truths not filled / not graded).
export default function AccuracyMeter({ answer, className = '' }) {
  const score = answer?.answer_score;
  if (score === null || score === undefined) {
    const labels = { pending: '等候評分', processing: '評分中', failed: '評分暫未完成，待重試', no_truths: '未填真相，暫無評分' };
    return labels[answer?.scoring_status] ? <p className="text-xs text-[#5C5C5C]">{labels[answer.scoring_status]}</p> : null;
  }
  const t = accuracyTier(score);
  return (
    <div className={`max-w-[200px] ${className}`} data-testid="accuracy-meter">
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-[12px] text-[#5C5C5C]">本單準度</span>
        <span className="text-[15px] font-semibold leading-none" style={{ color: t.fill }}>{t.score}%</span>
      </div>
      <div className="h-1.5 rounded-full overflow-hidden" style={{ background: t.tint }}>
        <div className="h-full rounded-full" style={{ width: `${t.score}%`, background: t.fill }} />
      </div>
    </div>
  );
}
